import type { JobsListParams } from '@/api/jobs/jobs.api';

/**
 * The jobs list cannot ask for its rows until the app shell has loaded the
 * user, permissions and saved filters, then its lazy chunk — on demo2 the
 * request started ~3.5s in. Remembering the last first-page request lets the
 * app fire it during boot instead (`app/preloadJobsListRoute`), into the same
 * query entry the page reads.
 *
 * Only a hint: the page still builds its own params, and its query (keyed on
 * them, 30s staleTime) reuses the boot entry only when they are identical.
 */
const STORAGE_KEY = 'kula_jobs_list_last_request';

/** Records a first-page, unsearched request — the one a fresh visit starts on. */
export const saveLastJobsListRequest = (params: JobsListParams): void => {
  if (params.offset || params.q) return;
  try {
    // A cleared search leaves `q: ''`, but a fresh visit starts at `null`: same
    // URL, different query key, so the page would not reuse the boot entry.
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...params, q: null }));
  } catch {
    // Storage full or blocked: the list simply loads the usual way.
  }
};

export const readLastJobsListRequest = (): JobsListParams | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as JobsListParams) : null;
  } catch {
    return null;
  }
};
